import { Component, Inject, OnInit } from "@angular/core";
import { LOADER_DATA_VAR } from "../../../constants/loader.constants";

@Component({
  selector: "mis-employee-web-exp-loader-with-message",
  templateUrl: "./loader-with-message.component.html",
  styleUrls: ["./loader-with-message.component.scss"]
})
export class LoaderWithMessageComponent {
  constructor(@Inject(LOADER_DATA_VAR) public message: string) {}
}
